import React, { useState } from 'react'
import Box from '@mui/material/Box'
import ConfigOpenStackItem from './ConfigOpenStackItem'

const ConfigOpenStack = (props) => {
  const {
    selectedBackendServices,
    backendUserData,
    setBackendUserData,
    getRegionConfig,
    backendIsIdentityProviderSelected,
    errors,
    setErrors,
    submitted,
    validateFormFields,
    appCredentialSecret,
    setAppCredentialSecret,
  } = props

  const [expandedPanel, setExpandedPanel] = useState('identity_keystone')

  const handleChangeExpandedPanel = (panel) => (event, newExpanded) => {
    setExpandedPanel(newExpanded ? panel : false)
  }

  return (
    <Box sx={{ paddingBottom: '20px ' }}>
      {
        selectedBackendServices.map((item, index) => (
          <ConfigOpenStackItem
            key={index}
            {...item}
            expandedPanel={expandedPanel}
            handleChangeExpandedPanel={handleChangeExpandedPanel}
            backendUserData={backendUserData}
            setBackendUserData={setBackendUserData}
            getRegionConfig={getRegionConfig}
            backendIsIdentityProviderSelected={backendIsIdentityProviderSelected}
            errors={errors}
            setErrors={setErrors}
            submitted={submitted}
            validateFormFields={validateFormFields}
            appCredentialSecret={appCredentialSecret}
            setAppCredentialSecret={setAppCredentialSecret}
          />
        ))
      }
    </Box>
  )
}

export default ConfigOpenStack